import React, { forwardRef } from "react";
import * as _f_ from "@Funciones/funciones";

export const TextArea = forwardRef(
  ({ texto = "", tipo = "text", name, estilos = {}, ...props }, ref) => {
  
    return (
      <div className="TextArea5" style={_f_.estilosObjetoVariablesCSS(estilos)}>
        <textarea
          key={texto}
          type={tipo}
          name={name}
          id={`TextArea5`}
          className="TextArea5-campo"
          placeholder={texto}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);
